import { createContext, useContext, useState, useEffect, useMemo } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("lili-lang") : null;
    return saved || "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("lili-lang", lang);
    }
  }, [lang]);

  const value = useMemo(() => {
    const t = translations[lang] || translations.fr;
    const toggleLang = () => setLang((l) => (l === "fr" ? "en" : "fr"));
    return { lang, setLang, toggleLang, t };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
